import React from 'react';
import styled from 'styled-components';

const Loader = styled.div`
  margin: 100px auto;
  width: 40px;
  height: 40px;
  position: relative;
`;
const Dot = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;

  :before {
    content: '';
    display: block;
    margin: 0 auto;
    width: 15%;
    height: 15%;
    background-color: #333;
    border-radius: 100%;
    -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
    animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
  }

  @-webkit-keyframes sk-circleFadeDelay {
    0%,
    39%,
    100% {
      opacity: 0;
    }
    40% {
      opacity: 1;
    }
  }

  @keyframes sk-circleFadeDelay {
    0%,
    39%,
    100% {
      opacity: 0;
    }
    40% {
      opacity: 1;
    }
  }
`;
const Dot1 = styled(Dot)`
  -webkit-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  transform: rotate(30deg);

  :before {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
  }
`;
const Dot2 = styled(Dot)`
  -webkit-transform: rotate(60deg);
  -ms-transform: rotate(60deg);
  transform: rotate(60deg);
  :before {
    -webkit-animation-delay: -1s;
    animation-delay: -1s;
  }
`;
const Dot3 = styled(Dot)`
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
  :before {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
  }
`;
const Dot4 = styled(Dot)`
  -webkit-transform: rotate(120deg);
  -ms-transform: rotate(120deg);
  transform: rotate(120deg);
  :before {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
  }
`;
const Dot5 = styled(Dot)`
  -webkit-transform: rotate(150deg);
  -ms-transform: rotate(150deg);
  transform: rotate(150deg);
  :before {
    -webkit-animation-delay: -0.7s;
    animation-delay: -0.7s;
  }
`;
const Dot6 = styled(Dot)`
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
  :before {
    -webkit-animation-delay: -0.6s;
    animation-delay: -0.6s;
  }
`;
const Dot7 = styled(Dot)`
  -webkit-transform: rotate(210deg);
  -ms-transform: rotate(210deg);
  transform: rotate(210deg);
  :before {
    -webkit-animation-delay: -0.5s;
    animation-delay: -0.5s;
  }
`;
const Dot8 = styled(Dot)`
  -webkit-transform: rotate(240deg);
  -ms-transform: rotate(240deg);
  transform: rotate(240deg);
  :before {
    -webkit-animation-delay: -0.4s;
    animation-delay: -0.4s;
  }
`;
const Dot9 = styled(Dot)`
  -webkit-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  transform: rotate(270deg);
  :before {
    -webkit-animation-delay: -0.3s;
    animation-delay: -0.3s;
  }
`;
const Dot10 = styled(Dot)`
  -webkit-transform: rotate(300deg);
  -ms-transform: rotate(300deg);
  transform: rotate(300deg);
  :before {
    -webkit-animation-delay: -0.2s;
    animation-delay: -0.2s;
  }
`;
const Dot11 = styled(Dot)`
  -webkit-transform: rotate(330deg);
  -ms-transform: rotate(330deg);
  transform: rotate(330deg);

  :before {
    -webkit-animation-delay: -0.1s;
    animation-delay: -0.1s;
  }
`;

export default () => (
  <Loader>
    <Dot1 />
    <Dot2 />
    <Dot3 />
    <Dot4 />
    <Dot5 />
    <Dot6 />
    <Dot7 />
    <Dot8 />
    <Dot9 />
    <Dot10 />
    <Dot11 />
  </Loader>
);
